import { ChangeDetectorRef, Component, ElementRef, OnInit} from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';
import { WizEvent, WizEventManager, WizRoot } from '@wizeoo/akm-component-lib';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { RouteEngine } from 'src/app/manager/routing/route.engine';
import { Model } from 'src/app/model/model';

@Component({
  selector: 'information-bar',
  templateUrl: './information.bar.html'
})
export class InformationBar implements OnInit {

  constructor(protected cdref: ChangeDetectorRef, el: ElementRef) {
  }

  ngOnInit() {
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_END, this.refresh);
  }

  public currentView: string = 'home';
  

  public doShow(view: string): boolean {
    const currV: BaseView = Model.getInstance().navigationEngine.getCurrentView();
    //let curr: string = this.currentView;
    if(this.currentView.toUpperCase() !== view.toUpperCase()) {
      return true;
    }
    return false;
  }

  public get isVerbose(): boolean {
    return WizRoot.verboseMode;
  }

  public refresh(e: WizEvent): void {
    this.currentView = e.value;
  } 

  /** déclenche une action */
  public do(action: string): void {
   switch (action) {   
      case "home":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.INIT_VIEW);
        break;
      case "list":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.LIST_VIEW);
        break; 
      case "thumb":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.THUMB_VIEW);
        break;  
      case "gatling":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.GATLING_VIEW);
        break; 
      case "log":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.LOG_VIEW);
        break;       
      case "add":  
          Model.getInstance().currentPrototype = null;
          Model.getInstance().navigationEngine.navigate(RouteEngine.ADD_VIEW);
        break; 
      case "back":  
          window.history.back();
        break;    
    }
  }

}
